<template>
  <main>
    <page-header-compact>Validación de examen de laboratorio</page-header-compact>
    <div class="container-fluid px-4">
      
      <!-- Filter Bar -->
      <div class="card card-icon mb-3 mt-3 shadow-xs">
        <div class="row no-gutters">
          <div class="col-auto card-icon-aside bg-light text-primary">
            <i class="fa fa-flask fa-fw"></i>
          </div>
          <div class="col">
            <div class="card-body py-3">
              <div class="row align-items-end">
                <div class="col-lg-12 col-md-12 mt-2 mb-2 mt-md-0">
                  <span class="badge badge-light badge-marketing font-weight-bold text-sm italic">
                    Sede: {{ sede ? sede.NOMBRE_SEDE : 'No seleccionado' }}
                  </span>
                </div>
                <div class="col-lg-4 col-md-6 mt-3 mt-md-0">
                  <label class="form-label font-weight-bold text-gray-700 mb-1 small">Fecha</label>
                  <input
                    v-model="fecha"
                    class="form-control form-control-sm"
                    type="date"
                  />
                </div>
                
                <div class="col-lg-4 col-md-6 mt-2 mt-md-0">
                  <label class="form-label font-weight-bold text-gray-700 mb-1 small">No. muestra / Documento Paciente</label>
                  <input
                    v-model="pagination.search"
                    class="form-control form-control-sm"
                    type="text"
                    placeholder="Ingrese documento o muestra..."
                    @keyup.enter="cargarResultadosExamenes()"
                  />
                </div>
                <div class="col-lg-4 col-md-6 mt-2 mt-md-0 hidden" hidden>
                  <VselectSede
                    v-model="sede" 
                  ></VselectSede>
                </div>
                
                <div class="col-lg-4 col-md-6 mt-md-0 d-flex">
                  <button class="btn btn-primary btn-sm font-weight-bold " @click="cargarResultadosExamenes()">
                    <i class="fa fa-search fa-fw mr-1"></i> Buscar
                  </button>
                  <button class="btn btn-light btn-sm ml-2 font-weight-bold " @click="limpiarCampos()">
                    <i class="fa fa-search fa-fw mr-1"></i> Limpiar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="pagination.data && pagination.data.length === 0" class="alert alert-warning  shadow-sm">
        <i class="fas fa-exclamation-circle mr-2"></i> No se encontraron resultados de laboratorio para los criterios seleccionados...
      </div>

      <!-- DataGrid List -->
      <div class="card shadow-none border-0">
        <div class="card-body">
          <data-grid
            :data="pagination"
            :search-box="false"
            @search="search($event)"
          >
            <template #grid>
              
             

              <!-- Main Orders Loop -->
              <div v-for="item in pagination.data" :key="item.id" class="mb-4">
                
                <!-- Patient Info Header -->
                <div class="card card-icon mb-2 shadow-none border border-left-lg border-left-primary">
                  <div class="row no-gutters align-items-center">
                    <div v-if="item.orden_trabajo && item.orden_trabajo.usuario && item.orden_trabajo.usuario.sexo === 'F'" class="text-center col-auto pl-4 pr-0">
                      <div class="rounded-circle d-flex align-items-center justify-content-center border shadow-sm" style="width: 60px; height: 60px; background-color: #f8f9fa; border-color: #e9ecef !important;">
                        <img src="@/assets/img-genero/mujer.png" style="width: 46px; height: 46px; object-fit: contain;">
                      </div>
                    </div>
                    <div v-else-if="item.orden_trabajo && item.orden_trabajo.usuario && item.orden_trabajo.usuario.sexo === 'M'" class="text-center col-auto pl-4 pr-0">
                      <div class="rounded-circle d-flex align-items-center justify-content-center border shadow-sm" style="width: 60px; height: 60px; background-color: #f8f9fa; border-color: #e9ecef !important;">
                        <img src="@/assets/img-genero/hombre.png" style="width: 38px; height: 38px; object-fit: contain;">
                      </div>
                    </div>
                    <div class="col">
                      <div class="card-body py-2">
                        <!-- Top Row -->
                        <div class="row align-items-center">
                          <div class="col-md-7">
                            <h5 class="mb-1 font-weight-bold text-dark" v-if="item.orden_trabajo && item.orden_trabajo.usuario">
                              {{ item.orden_trabajo.usuario.nombre_1 }} {{ item.orden_trabajo.usuario.nombre_2 }}
                              {{ item.orden_trabajo.usuario.apellido_1 }} {{ item.orden_trabajo.usuario.apellido_2 }}
                            </h5>
                            <div class="small text-muted" v-if="item.orden_trabajo && item.orden_trabajo.usuario">
                              <strong class="text-gray-800 font-weight-bold text-sm">{{item.orden_trabajo.usuario.tipo_documento.codigo}} {{ item.orden_trabajo.usuario.documento }}</strong> -
                              <span class="font-weight-bold text-gray-800 text-sm"> {{ item.orden_trabajo.usuario.years }} años</span>
                            </div>
                            <div class="mt-1" v-if="item.orden_trabajo">
                              <span class="badge badge-light border text-gray-600 font-weight-bold px-2 py-1" style="font-size: 0.75rem; letter-spacing: 0.2px;">
                                <i class="fas fa-shield-alt mr-1 text-muted"></i> EPS: {{ item.orden_trabajo.eps ? item.orden_trabajo.eps.DESEPS : 'Sin EPS' }}
                              </span>
                            </div>
                          </div>
                          <div class="col-md-5 text-md-right mt-2 mt-md-0 d-flex justify-content-md-end align-items-center">
                            <span class="badge badge-light border text-gray-700 px-3 py-2 font-weight-bold" style="font-size: 0.8rem;">
                              <i class="fas fa-file-invoice mr-1 text-muted"></i> Orden No: {{ item.orden_trabajo ? item.orden_trabajo.id : item.id }}
                            </span>
                          </div>
                        </div>

                        <!-- Bottom Row (Grid with Muestra, Sede, Fecha) -->
                        <div class="row mt-2 pt-2 border-top align-items-center">
                          <!-- Muestra -->
                          <div class="col-md-3 col-sm-6 d-flex align-items-center mb-2 mb-md-0">
                            <i class="fas fa-flask mr-2" style="font-size: 1.25rem; width: 20px; text-align: center; color: #855CF8;"></i>
                            <div>
                              <div class="text-muted mb-0" style="font-size: 0.7rem; font-weight: 600; text-transform: uppercase;">Muestra</div>
                              <div class="font-weight-bold text-dark mb-0" style="font-size: 0.95rem;">
                                {{ item.orden_trabajo ? item.orden_trabajo.toma_muestra : 'N/A' }}
                              </div>
                            </div>
                          </div>

                          <!-- Sede -->
                          <div class="col-md-5 col-sm-6 d-flex align-items-center mb-2 mb-md-0">
                            <i class="far fa-building mr-2" style="font-size: 1.25rem; width: 20px; text-align: center; color: #1B63FF;"></i>
                            <div>
                              <div class="text-muted mb-0" style="font-size: 0.7rem; font-weight: 600; text-transform: uppercase;">Sede</div>
                              <div class="font-weight-bold text-dark mb-0" style="font-size: 0.95rem;" v-if="item.orden_trabajo && item.orden_trabajo.sede">
                                {{ item.orden_trabajo.sede.NOMBRE_SEDE }}
                              </div>
                              <div class="font-weight-bold text-dark mb-0" style="font-size: 0.95rem;" v-else>
                                N/A
                              </div>
                            </div>
                          </div>

                          <!-- Fecha -->
                          <div class="col-md-4 col-sm-6 d-flex align-items-center">
                            <i class="far fa-calendar-alt mr-2" style="font-size: 1.25rem; width: 20px; text-align: center; color: #FF6060;"></i>
                            <div>
                              <div class="text-muted mb-0" style="font-size: 0.7rem; font-weight: 600; text-transform: uppercase;">Fecha</div>
                              <div class="font-weight-bold text-dark mb-0" style="font-size: 0.95rem;">
                                {{ item.fecha | formatDate }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- AREAS & EXAMS TABS -->
                <div class="card shadow-none mt-2">
                  <div class="card-header border-bottom">
                    <ul class="nav nav-tabs card-header-tabs" :id="`pills-tab-${item.id}`" role="tablist">
                      <li v-for="(area, i) in getGroupedAreas(item)" :key="area.id" class="nav-item">
                        <a
                          :id="`nav_${item.id}_${area.id}`"
                          :class="{ active: i === 0 }"
                          :href="`#tab_${item.id}_${area.id}`"
                          class="nav-link text-uppercase font-weight-bold small px-3 mr-2"
                          data-toggle="tab"
                          role="tab"
                        >
                          {{ area.nombre }}
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div class="card-body">
                    <div class="tab-content" :id="`nav-tabContent-${item.id}`">
                      <div
                        v-for="(area, i) in getGroupedAreas(item)"
                        :id="`tab_${item.id}_${area.id}`"
                        :key="`tab_${item.id}_${area.id}`"
                        :class="{ 'show active': i === 0 }"
                        class="tab-pane fade"
                        role="tabpanel"
                      >
                        <!-- Table Header -->
                        <div class="card-header bg-gray-100">
                          <div class="row align-items-center no-gutters text-uppercase font-weight-bold text-gray-600" style="font-size: 0.7rem; letter-spacing: 0.05em;">
                            <div class="col-auto pr-2" style="width: 32px;">
                              <div class="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  class="custom-control-input"
                                  :id="`select_all_${item.id}_${area.id}`"
                                  :checked="isAreaAllSelected(area)"
                                  @change="toggleSelectArea(area, $event)"
                                />
                                <label class="custom-control-label cursor-pointer" :for="`select_all_${item.id}_${area.id}`"></label>
                              </div>
                            </div>
                            <div class="col-lg-3">Determinación</div>
                            <div class="col-lg-3 text-center">Resultado</div>
                            <div class="col-lg-3 text-center">Valores Referencia</div>
                            <div class="col text-right pr-3 d-flex justify-content-end align-items-center">
                              <button
                                v-if="getSelectedForArea(area).length > 0"
                                type="button"
                                class="btn btn-danger btn-xs font-weight-bold shadow-xs py-1 px-2 d-inline-flex align-items-center"
                                style="font-size: 0.72rem; letter-spacing: 0; text-transform: none;"
                                @click="abrirModalEliminar(item, getSelectedForArea(area))"
                                title="Anular exámenes seleccionados de esta área"
                              >
                                <i class="fas fa-trash-alt mr-1"></i> Eliminar seleccionados ({{ getSelectedForArea(area).length }})
                              </button>
                              <span v-else>Estado / Validación</span>
                            </div>
                          </div>
                        </div>

                        <!-- EXAM LIST WITHIN AREA -->
                        <div class="list-group p-2">
                          <div v-for="(entry, index) in area.items" :key="index">
                            
                            <!-- CASE: GROUP (Examen Padre) -->
                            <template v-if="entry.type === 'group'">
                              <div class="bg-gray-200 px-3 py-2 border-bottom text-xs font-weight-bold text-dark small text-uppercase">
                                <i class="fas fa-list-ul text-primary mr-2"></i> {{ entry.nombre }}
                              </div>

                              <div v-for="detalle in entry.items" :key="detalle.id" class="list-group-item px-3 py-1 border-bottom border-light">
                                <div class="row align-items-center no-gutters">
                                  <div class="col-auto pr-2" style="width: 32px;">
                                    <div class="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        class="custom-control-input"
                                        :id="`check_detalle_${detalle.id}`"
                                        :value="detalle"
                                        v-model="selectedDetalles"
                                      />
                                      <label class="custom-control-label cursor-pointer" :for="`check_detalle_${detalle.id}`"></label>
                                    </div>
                                  </div>
                                  <div class="col-lg-3 pl-2 text-sm">
                                    <span class="font-weight-bold text-gray-700">{{ detalle.examenes ? detalle.examenes.nombre : 'Examen' }}</span>
                                  </div>
                                  <div class="col-lg-3">
                                    <texto v-if="detalle.examenes && detalle.examenes.tipo === 'texto'" v-model="detalle.resultado" :validado="detalle.validado"></texto>
                                    <numerico v-if="detalle.examenes && detalle.examenes.tipo === 'numero'" v-model="detalle.resultado" :validado="detalle.validado"></numerico>
                                    <opciones v-if="detalle.examenes && detalle.examenes.tipo === 'opcion'" v-model="detalle.resultado" :examen="detalle.examenes" :validado="detalle.validado"></opciones>
                                  </div>
                                  <div class="col-lg-3 text-center">
                                    <div v-if="detalle.examenes && (detalle.examenes.valores_referencia || detalle.examenes.unidad)" class="ref-value-box text-gray-600 font-weight-bold px-1 py-1" style="font-size: 0.75rem;">
                                      {{ detalle.examenes.valores_referencia }} <small class="ml-1">{{ detalle.examenes.unidad }}</small>
                                    </div>
                                    <span v-else class="text-muted small italic">N/A</span>
                                  </div>
                                  <div class="col text-right pr-3 d-flex justify-content-end align-items-center">
                                    <div v-if="detalle.validado === 0">
                                      <span class="badge badge-warning text-dark mr-2">Sin validar</span>
                                      <button class="btn btn-success btn-xs shadow-sm font-weight-bold" @click="validarExamen(detalle)">
                                        <i class="fa fa-check fa-fw mr-1"></i>Validar
                                      </button>
                                    </div>
                                    <div v-else>
                                      <span class="badge badge-success px-3 py-1 font-weight-bold">
                                        <i class="fas fa-check-circle mr-1"></i> Validado
                                      </span>
                                    </div>
                                    <button
                                      class="btn btn-outline-danger btn-xs ml-2 shadow-sm font-weight-bold"
                                      title="Anular este resultado"
                                      @click="eliminarIndividual(item, detalle)"
                                    >
                                      <i class="fas fa-trash-alt"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </template>

                            <!-- CASE: STANDALONE (Examen Independiente) -->
                            <div v-else class="list-group-item px-3 py-1 border-bottom border-light">
                              <div class="row align-items-center no-gutters">
                                <div class="col-auto pr-2" style="width: 32px;">
                                  <div class="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      class="custom-control-input"
                                      :id="`check_entry_${entry.id}`"
                                      :value="entry"
                                      v-model="selectedDetalles"
                                    />
                                    <label class="custom-control-label cursor-pointer" :for="`check_entry_${entry.id}`"></label>
                                  </div>
                                </div>
                                <div class="col-lg-3 text-sm">
                                  <span class="font-weight-bold text-dark">{{ entry.examenes ? entry.examenes.nombre : 'Examen' }}</span>
                                </div>
                                <div class="col-lg-3">
                                  <texto v-if="entry.examenes && entry.examenes.tipo === 'texto'" v-model="entry.resultado" :validado="entry.validado"></texto>
                                  <numerico v-if="entry.examenes && entry.examenes.tipo === 'numero'" v-model="entry.resultado" :validado="entry.validado"></numerico>
                                  <opciones v-if="entry.examenes && entry.examenes.tipo === 'opcion'" v-model="entry.resultado" :examen="entry.examenes" :validado="entry.validado"></opciones>
                                </div>
                                <div class="col-lg-3 text-center">
                                  <div v-if="entry.examenes && (entry.examenes.valores_referencia || entry.examenes.unidad)" class="ref-value-box text-gray-600 font-weight-bold px-1 py-1" style="font-size: 0.75rem;">
                                    {{ entry.examenes.valores_referencia }} <small class="ml-1">{{ entry.examenes.unidad }}</small>
                                  </div>
                                  <span v-else class="text-muted small italic">N/A</span>
                                </div>
                                <div class="col text-right pr-3 d-flex justify-content-end align-items-center">
                                  <div v-if="entry.validado === 0">
                                    <span class="badge badge-warning text-dark mr-2">Sin validar</span>
                                    <button class="btn btn-success btn-xs shadow-sm font-weight-bold" @click="validarExamen(entry)">
                                      <i class="fa fa-check fa-fw mr-1"></i>Validar
                                    </button>
                                  </div>
                                  <div v-else>
                                    <span class="badge badge-success px-3 py-1 font-weight-bold">
                                      <i class="fas fa-check-circle mr-1"></i> Validado
                                    </span>
                                  </div>
                                  <button
                                    class="btn btn-outline-danger btn-xs ml-2 shadow-sm font-weight-bold"
                                    title="Anular este resultado"
                                    @click="eliminarIndividual(item, entry)"
                                  >
                                    <i class="fas fa-trash-alt"></i>
                                  </button>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </template>
          </data-grid>
        </div>
      </div>

      <!-- Modal Eliminar / Anular Resultados -->
      <modal-eliminar-resultados
        ref="modalEliminar"
        @eliminado="onResultadosEliminados"
        @cancelar="selectedDetalles = []"
      ></modal-eliminar-resultados>

      <!-- Floating Action Bar when items are selected -->
      <transition name="slide-up">
        <div
          v-if="selectedDetalles.length > 0"
          class="floating-selection-bar shadow-lg d-flex align-items-center justify-content-between px-3 py-2 rounded-pill"
        >
          <div class="d-flex align-items-center mr-3">
            <span class="badge badge-danger rounded-circle mr-2 d-flex align-items-center justify-content-center font-weight-bold" style="width: 22px; height: 22px; font-size: 0.72rem;">
              {{ selectedDetalles.length }}
            </span>
            <span class="text-white small font-weight-bold">
              {{ selectedDetalles.length === 1 ? '1 examen seleccionado' : `${selectedDetalles.length} exámenes seleccionados` }}
            </span>
          </div>
          <div class="d-flex align-items-center">
            <button
              type="button"
              class="btn btn-link text-white-50 btn-sm small py-0 px-2 mr-2 font-weight-bold text-decoration-none"
              @click="selectedDetalles = []"
              title="Limpiar selección"
            >
              <i class="fas fa-times mr-1"></i> Deseleccionar
            </button>
            <button
              type="button"
              class="btn btn-danger btn-sm font-weight-bold rounded-pill px-3 shadow-sm"
              @click="abrirModalEliminarDesdeFlotante()"
            >
              <i class="fas fa-trash-alt mr-1"></i> Eliminar seleccionados
            </button>
          </div>
        </div>
      </transition>

    </div>
  </main>
</template>

<script>
import PageHeaderCompact from "../../../../../components/layouts/content/page-header-compact";
import resultadosLaboratorioService from "../../../../../services/resultadosLaboratorioService";
import Toast from "../../../../../components/common/utilities/toast";
import DataGrid from "../../../../../components/common/utilities/DataGrid/DataGrid";
import paginateMixin from "../../../../../mixins/PaginateMixin";
import texto from "../../../../../views/historias/base/resultadosLaboratorios/tipos/texto";
import numerico from "../../../../../views/historias/base/resultadosLaboratorios/tipos/numerico";
import opciones from "../../../../../views/historias/base/resultadosLaboratorios/tipos/opciones";
import VselectSede from "../../../../../components/common/VSelectSede.vue";
import modalEliminarResultados from "./modalEliminarResultados.vue";
export default {
  components: {
    PageHeaderCompact,
    DataGrid,
    texto,
    numerico,
    opciones,
    VselectSede,
    modalEliminarResultados
  },
  mixins: [
    paginateMixin(async (search = "", pagination = {}) =>
      resultadosLaboratorioService.index(search, pagination)
    ),
  ],
  data() {
    return {
      Isdisabled: false,
      resultadosExamenes: [],
      selectedDetalles: [],
      fecha: "",
      id_profesional: "",
      sede:'',
      pagination: {
        per_page: 1,
        params: {
          id_profesional: "",
          fecha: "",
          id_sede: "",
        },
      },
    };
  },
  watch: {
    "pagination.data": {
      handler: function () {
        this.calcularMicroalbuminuriaCreatinina();
        this.selectedDetalles = [];
      },
      deep: true,
    },
    campus: {
      handler: function (newCampus) {
        if (newCampus) {
          this.sede = {
            ID: newCampus.ID,
            NOMBRE_SEDE: newCampus.NOMBRE_SEDE,
            text: newCampus.CODIGO + ' - ' + newCampus.NOMBRE_SEDE,
          };
        }
      },
      immediate: true,
    },
  },
  computed: {
    campus(){
        return this.$store.state.campus;
    }
  },
  methods: {
    calcularMicroalbuminuriaCreatinina() {
      if (!this.pagination.data || !this.pagination.data.length) return;

      this.pagination.data.forEach(order => {
        if (!order.detalles || !order.detalles.length) return;

        let malb = null;
        let crea = null;
        let targetItem = null;

        order.detalles.forEach(detalle => {
          const abbr = detalle.examenes ? detalle.examenes.abbr_name : '';
          if (abbr === 'mALB-O') {
            malb = detalle;
          } else if (abbr === 'CREA-O') {
            crea = detalle;
          } else if (abbr === 'mALB-CR') {
            targetItem = detalle;
          }
        });

        if (malb && crea && targetItem) {
          const valMalb = parseFloat(malb.resultado);
          const valCrea = parseFloat(crea.resultado);

          if (!isNaN(valMalb) && !isNaN(valCrea) && valCrea !== 0) {
            const calculated = ((valMalb / valCrea) * 100).toFixed(2);
            if (targetItem.resultado !== calculated) {
              targetItem.resultado = calculated;
            }
          } else {
            if (targetItem.resultado !== '') {
              targetItem.resultado = '';
            }
          }
        }
      });
    },
    /**
     * Agrupa los detalles de resultados de un orden de trabajo por Área y Examen Padre.
     */
    getGroupedAreas(item) {
      if (!item || !item.detalles || !item.detalles.length) {
        return [];
      }

      let areasMap = {};

      item.detalles.forEach((detalle) => {
        if (!detalle.examenes) return;

        const ex = detalle.examenes;
        const area = ex.area || { id: ex.id_area || 0, nombre: "Área General" };
        const areaId = area.id || 0;

        if (!areasMap[areaId]) {
          areasMap[areaId] = {
            id: areaId,
            nombre: area.nombre || "Área General",
            items: [],
          };
        }

        // Buscar id_examen padre y nombre del examen padre
        const idPadre = ex.id_examen;
        const parentName =
          (ex.examen_padre ? ex.examen_padre.nombre : null) ||
          (ex.padre ? ex.padre.nombre : null) ||
          (ex.examen ? ex.examen.nombre : null);

        if (idPadre && idPadre !== ex.id && parentName) {
          let group = areasMap[areaId].items.find(
            (x) => x.type === "group" && x.id === idPadre
          );

          if (!group) {
            group = {
              type: "group",
              id: idPadre,
              nombre: parentName,
              orden: (ex.examen_padre ? ex.examen_padre.orden : null) ||
                     (ex.padre ? ex.padre.orden : null) ||
                     (ex.examen ? ex.examen.orden : null),
              items: [],
            };
            areasMap[areaId].items.push(group);
          }
          group.items.push(detalle);
        } else {
          // Examen independiente / standalone
          detalle.type = "item";
          areasMap[areaId].items.push(detalle);
        }
      });

      Object.keys(areasMap).forEach((areaId) => {
        // 1. Sort the items within each group
        areasMap[areaId].items.forEach((item) => {
          if (item.type === "group" && item.items) {
            item.items.sort((a, b) => {
              const oA = (a.examenes && a.examenes.orden !== null && a.examenes.orden !== undefined && a.examenes.orden !== "") ? parseInt(a.examenes.orden) : Infinity;
              const oB = (b.examenes && b.examenes.orden !== null && b.examenes.orden !== undefined && b.examenes.orden !== "") ? parseInt(b.examenes.orden) : Infinity;
              return oA - oB;
            });
          }
        });

        // 2. Sort the top-level items of the area (standalone and groups)
        areasMap[areaId].items.sort((a, b) => {
          const getOrdenVal = (node) => {
            if (node.type === "group") {
              if (node.orden !== undefined && node.orden !== null && node.orden !== "") return parseInt(node.orden);
              if (node.items && node.items.length) {
                const firstItem = node.items[0];
                if (firstItem.examenes && firstItem.examenes.examen_padre && firstItem.examenes.examen_padre.orden !== undefined && firstItem.examenes.examen_padre.orden !== null) {
                  return parseInt(firstItem.examenes.examen_padre.orden);
                }
              }
              return Infinity;
            }
            const val = node.examenes ? node.examenes.orden : null;
            return (val !== undefined && val !== null && val !== "") ? parseInt(val) : Infinity;
          };

          return getOrdenVal(a) - getOrdenVal(b);
        });
      });

      return Object.values(areasMap);
    },

    async cargarResultadosExamenes() {
      this.selectedDetalles = [];
      try {
        

        this.LoaderSpinnerShow();

        this.pagination.params.fecha = this.fecha;
        this.pagination.params.id_profesional = this.id_profesional;
        this.pagination.params.id_sede = this.sede.ID;
        const response = await resultadosLaboratorioService.index(
          this.pagination.search,
          this.pagination
        );
        this.resultadosExamenes = response.data;
        this.pagination.data = response.data.data;
        this.pagination.current_page = response.data.current_page;
        this.pagination.total = response.data.total;
        this.LoaderSpinnerHide();
      } catch (error) {
        console.log(error);
        this.LoaderSpinnerHide();
        Toast.fire({
          icon: "error",
          title: "Ha ocurrido un error al procesar la solicitud",
        });
      }
    },

    async validarExamen(detalle) {
      try {
        await resultadosLaboratorioService.cambiarEstado(
          detalle.id,
          detalle.resultado
        );
        detalle.validado = 1;
        Toast.fire({
          icon: "success",
          title: "Examen validado con éxito",
        });
      } catch (error) {
        console.error(error);
        Toast.fire({
          icon: "error",
          title: "Ha ocurrido un error al validar el examen",
        });
      }
    },
    limpiarCampos() {
      this.fecha = '';
      this.pagination.search = '';
      this.selectedDetalles = [];
      this.cargarResultadosExamenes();
    },

    getSelectedForOrder(orderId) {
      return this.selectedDetalles.filter((d) => d.resultado_id === orderId);
    },

    getSelectedForArea(area) {
      const flatItems = this.getFlatDetallesFromArea(area);
      const flatIds = flatItems.map((d) => d.id);
      return this.selectedDetalles.filter((d) => flatIds.includes(d.id));
    },

    getFlatDetallesFromArea(area) {
      let list = [];
      if (!area || !area.items) return list;
      area.items.forEach((entry) => {
        if (entry.type === "group" && entry.items) {
          list.push(...entry.items);
        } else {
          list.push(entry);
        }
      });
      return list;
    },

    isAreaAllSelected(area) {
      const flatItems = this.getFlatDetallesFromArea(area);
      if (!flatItems.length) return false;
      return flatItems.every((d) =>
        this.selectedDetalles.some((s) => s.id === d.id)
      );
    },

    toggleSelectArea(area, event) {
      const checked = event.target.checked;
      const flatItems = this.getFlatDetallesFromArea(area);
      if (checked) {
        flatItems.forEach((d) => {
          if (!this.selectedDetalles.some((s) => s.id === d.id)) {
            this.selectedDetalles.push(d);
          }
        });
      } else {
        const idsToRemove = flatItems.map((d) => d.id);
        this.selectedDetalles = this.selectedDetalles.filter(
          (d) => !idsToRemove.includes(d.id)
        );
      }
    },

    abrirModalEliminar(itemOrder, customSeleccionados = null) {
      const order =
        itemOrder || (this.pagination.data && this.pagination.data[0]);
      if (!order) return;
      const seleccionados =
        customSeleccionados || this.getSelectedForOrder(order.id);
      if (!seleccionados.length) {
        Toast.fire({
          icon: "warning",
          title: "Debe seleccionar al menos un examen para eliminar",
        });
        return;
      }
      this.$refs.modalEliminar.abrir(
        order,
        seleccionados,
        this.sede ? this.sede.ID : null
      );
    },

    abrirModalEliminarDesdeFlotante() {
      if (!this.selectedDetalles.length) return;
      const firstDetalle = this.selectedDetalles[0];
      const order =
        (this.pagination.data &&
          this.pagination.data.find(
            (o) => o.id === firstDetalle.resultado_id
          )) ||
        (this.pagination.data && this.pagination.data[0]);

      if (order) {
        this.abrirModalEliminar(order, this.selectedDetalles);
      }
    },

    eliminarIndividual(itemOrder, detalle) {
      this.$refs.modalEliminar.abrir(
        itemOrder,
        [detalle],
        this.sede ? this.sede.ID : null
      );
    },

    onResultadosEliminados() {
      this.selectedDetalles = [];
      this.cargarResultadosExamenes();
    },
  },
};
</script>

<style scoped>
.ref-value-box {
  background-color: #f1f5f9;
  border-radius: 4px;
  display: inline-block;
  max-width: 100%;
  white-space: normal;
  word-wrap: break-word;
  text-align: right;
  line-height: 1.2;
}

.bg-gray-100 {
  background-color: #f1f5f9 !important;
}

.bg-gray-200 {
  background-color: #eaecf4 !important;
}

.badge-primary-soft {
  background-color: rgba(78, 115, 223, 0.1);
  color: #4e73df;
}

.badge-info-soft {
  background-color: rgba(54, 185, 204, 0.1);
  color: #36b9cc;
}

.border-left-primary {
  border-left: 0.25rem solid #4e73df !important;
}

.floating-selection-bar {
  position: fixed;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1040;
  background-color: #1e293b;
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.4), 0 8px 10px -6px rgba(0, 0, 0, 0.25);
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.25s ease-out;
}

.slide-up-enter,
.slide-up-leave-to {
  opacity: 0;
  transform: translate(-50%, 25px);
}
</style>
